<template>

    <transition
            name="interactive-fade"
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
            mode="out-in">

        <!-- MOBILE INTERACTIVE -->
        <div class="mobile-interactive">
            <section id="base-container" data-sticky-container>

                <header class="sticky" data-sticky-wrap>
                    <div class="inner">
                        <branding
                            :logo="company.logo"
                            :altText="company.company_name"
                            :link="company.url"
                            addClass="mobile"
                            linkTarget="_blank"
                            v-if="loaded"></branding>
                    </div>
                </header>

                <div class="main" :class="{ 'not-entered': !hasEntered }" data-sticky-container>

                    <vue-tabs @tab-change="handleTabChange" v-model="tabName">

                        <v-tab title="Exposures">
                            <mobile-content-exposures></mobile-content-exposures>
                        </v-tab>

                        <v-tab :title="addCoverageLabel" v-if="hasCoverages">
                            <mobile-content-coverages></mobile-content-coverages>
                        </v-tab>

                        <v-tab :title="contactData.form_label">
                            <mobile-content-contact></mobile-content-contact>
                        </v-tab>

                    </vue-tabs>

                    <div class="panel-content">

                        <section data-type="landing" v-if="!hasEntered" :class="{ 'active': !hasEntered }">
                            <div class="inner">
                                <mobile-landing></mobile-landing>
                            </div>
                        </section>

                        <section data-type="privacy">
                            <div class="inner">
                                <mobile-content-privacy></mobile-content-privacy>
                            </div>
                        </section>

                        <section data-type="terms">
                            <div class="inner">
                                <mobile-content-terms></mobile-content-terms>
                            </div>
                        </section>

                    </div>

                </div>


                <footer>
                    <div class="inner">

                        <!-- SHARE -->
                        <div class="share-control">
                            <a @click="shareApp" title="Share">
                                <span class="icon"><i class="icon-MBR_share" aria-hidden="true"></i></span>
                            </a>
                            <share-controls></share-controls>
                            <hr />
                        </div>

                        <!-- CONTACT LINK -->
                        <div class="contact-link" v-if="contact.show">
                            <span v-html="contact.text"></span> <br /><a @click="changeTab(contactData.form_label)" :style="{ color: cssPropColor('$color-primary') }" v-html="contact.link.label"></a>
                        </div>
                        <!-- END CONTACT LINK -->

                        <!-- DISCLAIMER -->
                        <div v-if="disclaimerActive" class="disclaimer" v-html="disclaimer"></div>
                        <!-- END DISCLAIMER -->

                        <!-- NAV - LEGAL -->
                        <nav class="legal">
                            <ul>
                                <!-- PRIVACY -->
                                <li>
                                    <a @click="showPanel('privacy')" :class="" title="Privacy Policy">
                                        <span class="label">Privacy Policy</span>
                                    </a>
                                </li>
                                <!-- TERMS -->
                                <li>
                                    <a @click="showPanel('terms');" :class="" title="Terms and Conditions">
                                        <span class="label">Terms and Conditions</span>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                        <!-- END NAV - LEGAL -->

                    </div>
                </footer>

            </section>
        </div>
        <!-- END MOBILE INTERACTIVE -->

    </transition>

</template>


<script>

    import Branding from "./Branding.vue";
    import { VueTabs, VTab } from 'vue-nav-tabs';
    import 'vue-nav-tabs/themes/vue-tabs.css'
    import { TweenMax, CSSPlugin, EasePack, TextPlugin } from 'gsap';
    import MobileContentContact from "./MobileContentContact.vue";
    import MobileContentPrivacy from "./MobileContentPrivacy.vue";
    import MobileContentTerms from "./MobileContentTerms.vue";
    import MobileContentCoverages from "./MobileContentCoverages.vue";
    import MobileContentExposures from "./MobileContentExposures.vue";
    import MobileLanding from "./MobileLanding.vue";
    import Sticky from 'sticky-js';
    import ShareControls from "./ShareControls";



    let vm = {};

    export default {

        name: 'mobile-interactive',

        components: {
            ShareControls,
            MobileLanding,
            MobileContentExposures,
            MobileContentCoverages,
            MobileContentTerms,
            MobileContentPrivacy,
            MobileContentContact,
            Branding,
            VueTabs,
            VTab
        },

        data() {
            return {
                zoomed: false,
                residenceImage: '/static/images/MBR-055_House-Layered_Base.jpg',
                exposureObjects: {},
                contact: {
                    text: 'Ready to take the next step?',
                    link: {
                        label: 'Contact us today'
                    },
                    show: true
                },
                tabName: null,
                panelOpen: false,
                stickyHeader: null,
                stickyNav: null,
                disclaimerActive: false,
                shouldHideGrid: false
            }
        },

        computed: {

            hasEntered() {
                return this.$dataStore.getters.getEnteredState;
            },

            loaded() {
                return this.$dataStore.getters.getLoadedState;
            },

            company() {
                return this.$dataStore.getters.getCompany;
            },

            exposures() {
                return this.$dataStore.getters.getExposures;
            },

            hasCoverages() {
                let _coverages = this.$dataStore.getters.getCoverages;
                return (_coverages.length > 0);
            },

            contactData() {
                return this.$dataStore.getters.getCompanyContactData;
            },

            addCoverageLabel() {
                return this.$dataStore.getters.getAdditionalCoveragesLabel;
            },

            disclaimer() {
                return this.$dataStore.getters.getExposureDisclaimer;
            }

        },

        created() {
            //console.info('%cMobileInteractive::created', 'color:dodgerblue;');
            vm = this;

            this.$eventBus.$on('footer:disclaimer:show', vm.showDisclaimer);
            this.$eventBus.$on('footer:disclaimer:hide', vm.hideDisclaimer);

            this.$eventBus.$on('footer:contact:show', vm.showContact);
            this.$eventBus.$on('footer:contact:hide', vm.hideContact);

            this.$eventBus.$on('tab:change', (tab, type, opt) => vm.changeTab(tab, type, opt));

            this.$eventBus.$on('branding:loaded', vm.stickIt);

            if ( /webkit.*mobile/i.test(navigator.userAgent)) {
                (function($) {
                    $.fn.offsetOld = $.fn.offset;
                    $.fn.offset = function() {
                        var result = this.offsetOld();
                        result.top -= window.scrollY;
                        result.left -= window.scrollX;
                        return result;
                    };
                })(jQuery);
            }
        },

        mounted() {
            //console.info('%cMobileInteractive::mounted', 'color:green;');
            vm = this;

            // loaded
            vm.$dataStore.dispatch('LOADED', { val: true });

            $('.main').on('click', '.nav-tabs li', function() {
                vm.hidePanels();
            });

        },

        watch: {
            panelOpen: function(val) {
                if (vm.panelOpen) {
                    $('.tab-content').addClass('inactive');
                } else {
                    $('.tab-content').removeClass('inactive');
                }
            }
        },

        methods: {

            stickIt() {
                let mHeight = $('header').height();
                $('.nav-tabs-navigation').attr('data-sticky-wrap', '').attr('data-margin-top', mHeight).addClass('sticky');
                vm.stickyHeader = new Sticky('.sticky');
                vm.stickyHeader.update();
            },

            changeTab(tab, type, opt) {

                vm.hidePanels();
                vm.tabName = tab;
                console.log('tab', tab);
                console.log('type', type);
                console.log('opt', opt);


                if (type) {
                    switch(type) {
                        case 'off-premise':

                            setTimeout(function() {

                                let _header         = $('header'),
                                    _tabs           = $('.nav-tabs-navigation'),
                                    _headerHeight   = (typeof _header !== 'undefined') ? _header.height() : 0,
                                    _tabHeight      = (typeof _tabs !== 'undefined') ? _tabs.height() : 0;

                                console.log('type', type);
                                console.log('_headerHeight', _headerHeight);
                                console.log('_tabHeight', _tabHeight);
                                console.log('$(\'#anchor_\' + type)', $('#anchor_' + type));
                                console.log('$(\'#anchor_\' + type).offset().top', Math.ceil($('#anchor_' + type).offset().top));
                                console.log('Math.ceil((($(\'#anchor_\' + type).offset().top) - (_headerHeight + _tabHeight)) - 30)', Math.ceil((($('#anchor_' + type).offset().top) - (_headerHeight + _tabHeight)) - 30));

                                $('html, body').animate({
                                    scrollTop: Math.ceil((($('#anchor_' + type).offset().top) - (_headerHeight + _tabHeight)) - 30)
                                }, 300);

                            }, 600);
                            break;
                        case 'service-line':

                            break;
                    }
                }
            },

            handleTabChange(idx, nTab, oTab) {
                console.log(idx, nTab, oTab);
                this.$eventBus.$emit('exposure:return');
                this.$dataStore.dispatch('ENTER_INTERACTIVE', { val: true });
                $('.tab-content').removeClass('inactive');

                var numTabs = $('.nav-tabs .tab').length;

                switch(idx) {
                    case 0:
                        vm.trackEvent('Exposures Button');
                        this.$eventBus.$emit('exposures:enabled');
                        this.$eventBus.$emit('footer:contact:show');
                        break;
                    case 1:
                        if (numTabs === 3) {
                            vm.trackEvent('Additional Coverages Button');
                            this.$eventBus.$emit('footer:contact:show');
                        } else if (numTabs === 2) {
                            vm.trackEvent('Contact Us Button');
                            this.$eventBus.$emit('footer:contact:hide');
                        }
                        break;
                    case 2:
                        vm.trackEvent('Contact Us Button');
                        this.$eventBus.$emit('footer:contact:hide');
                        break;
                }
            },

            showPanel(panel) {
                $('html,body').scrollTop(0);
                vm.panelOpen = true;
                $('.panel-content section').removeClass('active');
                $('.panel-content section[data-type="' + panel + '"]').addClass('active');

                /*setTimeout(function() {
                    $('html,body').scrollTop(0);
                }, 150);*/
            },

            hidePanels() {
                $('html,body').scrollTop(0);
                /*setTimeout(function() {
                    $('html,body').scrollTop(0);
                }, 150);*/

                vm.panelOpen = false;
                $('.panel-content section').removeClass('active');
            },

            /**
             * @method togglePanel
             * @description
             * @param {String} type
             * @param {String} slug
             * @param {String} service
             * @param {String} premise
             */
            togglePanel(type, slug, service, premise) {
                //console.info('%ctogglePanel', 'color:orange;', type, slug, premise);

                this.$eventBus.$emit('panel:toggle', {
                    panel: type,
                    slug: slug,
                    service: service,
                    premise: premise
                });
            },

            /**
             * @method showContact
             * @description
             */
            showContact() {
                vm.contact.show = true;
            },

            /**
             * @method hideContact
             * @description
             */
            hideContact() {
                vm.contact.show = false;
            },

            showDisclaimer() {
                vm.disclaimerActive = true;
            },

            hideDisclaimer() {
                vm.disclaimerActive = false;
            },

            /**
             * @method shareApp
             * @description
             */
            shareApp() {
                //console.info('%cshareApp', 'color:orange;');
                this.$eventBus.$emit('share:toggle');
            },

            trackEvent(action, label) {
                gtag('event', action, {
                    'event_category': 'MBRe: Residential',
                    'event_label': label || ''
                });
            },

            /**
             * @method getCSSColorVariable
             * @description
             * @param color
             * @return {string}
             */
            getCSSColorVariable(color) {
                let _propVal = window.getComputedStyle(document.documentElement).getPropertyValue(color);

                if (!_propVal) {
                    let _color = color.replace('--', '$');
                    _propVal = window.appTheme.colors[_color];
                }

                //console.log('_propVal', _propVal);

                return _propVal;
            },

            /**
             * @method cssPropColor
             * @description
             */
            cssPropColor(colorProp) {
                if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                    return;
                } else {
                    return (window.appTheme.colors[colorProp]) ? window.appTheme.colors[colorProp] : false;
                }
            },

            /**
             * @method timeStampMs
             * @description
             * @return {number}
             */
            timeStampMs() {
                return window.performance && window.performance.now && window.performance.timing && window.performance.timing.navigationStart ? window.performance.now() + window.performance.timing.navigationStart : Date.now();
            }

        }

    }

</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/variables';

    .mobile-interactive {
        width: 100%;
        position: relative;

        & #base-container {
            width: 100%;
            height: 100%;
            display: flex;
            flex-flow: column nowrap;
            justify-content: flex-start;
            align-content: stretch;
            //align-items: flex-start;

            & header {
                background-color: $white-100;
                width: 100%;
                max-width: none;
                height: auto;
                min-height: 70px;
                max-height: 160px;
                box-shadow: 0 1px 3px rgba(74,74,74, 0.19);
                display: flex;
                justify-content: center;
                align-items: center;
                order: 0;
                flex: 1 0 auto;
                align-self: auto;
                position: relative;
                z-index: 99;

                & .branding {

                    &.horizontal {

                        & img {
                            max-height: 112px !important;
                        }
                    }

                    & img {
                        max-height: 112px !important;
                    }
                }
            }

            & .main {
                background-color: $white-100;
                width: 100%;
                max-width: none;
                order: 2;
                flex: 1 1 auto;
                align-self: auto;

                & .container {
                    width: 100%;
                    padding: 0 20px;
                }

                & .container-fluid {
                    padding: 0 0;
                }

                & .row {
                    display: flex;
                }

                & p {
                    font-size: 0.875rem;
                }

                & .panel-content {

                    & section {
                        max-height: 0;
                        opacity: 0;
                        overflow: hidden;
                        transition: all 0.1s ease-in-out;

                        &.active {
                            max-height: 20000px;
                            opacity: 1;
                            transition: all 0.1s ease-in-out;
                        }
                    }
                }
            }

            & footer {
                background-color: $white-100;
                margin: 1.250rem 1.875rem 0;
                padding: 1.250rem 0 1.750rem;
                border-top: 1px solid rgba(221,221,221, 1.0);
                display: block;
                order: 3;
                flex: 0 1 auto;
                align-self: auto;

                & .share-control {
                    margin-top: -0.5rem;
                    position: relative;

                    & > a {
                        color: $base-text-color;
                        text-decoration: none;
                    }

                    & hr {
                        margin-top: 0.5rem;
                    }

                    & .share-controls {
                        width: auto !important;

                        & .addthis_toolbox {
                            flex-flow: row nowrap !important;

                            & > a {
                                margin: 0 1px 1px 0 !important;
                            }
                        }
                    }
                }

                & .contact-link {
                    font-size: 0.875rem;
                    letter-spacing: initial;
                    line-height: 1.375;
                    margin: 0 0 2rem 0;
                }

                nav {

                    & ul {
                        list-style-type: none;
                        height: 100%;
                        margin: 0 0 0 0;
                        padding: 0 0 0 0;
                        display: flex;
                        flex-flow: row nowrap;

                        & > li {
                            margin: 0 0 0 0;

                            & a {
                                font-family: $font-univers-cond;
                                line-height: 1;
                                letter-spacing: 0.84px;
                                text-transform: uppercase;
                                width: 100%;
                                height: 100%;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                            }
                        }
                    }

                    &.legal {
                        padding: 0 0 0 0;
                        display: flex;
                        flex-flow: row nowrap;
                        justify-content: center;
                        align-self: stretch;
                        flex: 1 0 auto;

                        & li {
                            padding: 0 15px;
                        }

                        & a {
                            font-family: $font-univers-std;
                            font-size: 0.625rem;
                            letter-spacing: initial;
                            color: var(--color-base-text);
                            text-transform: none;

                            &:hover {
                                color: var(--color-primary);
                            }

                            &.active {
                                color: var(--color-primary);
                                text-decoration: none;
                            }
                        }
                    }
                }
            }
        }
    }

    .disclaimer {
        font-family: $font-univers-std;
        font-size: 0.688rem;
        font-weight: normal;
        line-height: 1.375;
        letter-spacing: 0;
        text-align: center;
        margin: 0 0 1.5rem 0;
        padding: 0 2rem;
    }

</style>

<style lang="scss">

    @import '../assets/styles/helpers/variables';

    .main {

        &.not-entered {

            & .vue-tabs {

                & .nav-tabs {

                    & .tab {

                        &.active {

                            &::before {
                                display: none !important;
                            }

                            & > a {
                                color: rgba(74,74,74, 1.0) !important;
                                text-decoration: none;
                            }
                        }
                    }
                }
            }
        }
    }

    .vue-tabs {
        z-index: 98;

        & .nav-tabs-navigation {
            background-color: $white-100;
            box-shadow: 0 1px 3px rgba(210,210,210, 0.67);
            position: relative;
            z-index: 98;
        }

        & .tab-content {
            max-height: 9999px;
            opacity: 1;
            overflow: hidden;
            position: relative;
            z-index: 90;
            transition: all 0.1s ease-in-out;

            &.inactive {
                max-height: 0;
                opacity: 0;
                transition: all 0.1s ease-in-out;
            }
        }

        & .nav-tabs {
            display: flex;
            flex-flow: row nowrap;

            & .tab {

                &.active {

                    &::before {
                        content: '';
                        background-color: var(--color-primary);
                        width: 100%;
                        height: 2px;
                        position: absolute;
                        top: 0;
                        left: 0;
                    }

                    & > a {
                        color: var(--color-primary) !important;
                        text-decoration: none !important;
                    }
                }

                &.disabled {

                    &::before {
                        content: '';
                        background-color: var(--color-primary);
                        width: 100%;
                        height: 2px;
                        display: none;
                        position: absolute;
                        top: 0;
                        left: 0;
                    }

                    & > a {
                        color: rgba(74,74,74, 1.0) !important;
                        text-decoration: none !important;
                    }
                }
            }

            & > li {
                height: 58px;
                border-right: 1px solid rgba(221,221,221, 0.42);
                float: none;
                display: flex !important;
                justify-content: center;
                align-items: center;
                flex: 1 1 33%;
                position: relative;

                &:last-of-type {
                    border-right: none;
                }

                &.active {

                    & > a {
                        background-color: $transparent !important;
                        border: none !important;
                        border-bottom-color: $transparent !important;
                        text-decoration: none;

                        &:hover {
                            background-color: transparent !important;
                            border-color: $transparent $transparent $transparent !important;
                        }

                        &:focus {
                            background-color: $transparent !important;
                        }
                    }
                }

                &.disabled {
                    & > a {
                        text-decoration: none;

                        &:hover {
                            background-color: transparent !important;
                            border-color: $transparent $transparent $transparent !important;
                        }

                        &:focus {
                            background-color: $transparent !important;
                        }
                    }
                }

                & > a {
                    font-family: $font-univers-cond;
                    font-size: 0.750rem;
                    color: rgba(74,74,74, 1.0) !important;
                    line-height: 1.250;
                    letter-spacing: 0.77px;
                    text-transform: uppercase;
                    border-radius: 0 !important;
                    text-decoration: none;

                    &:hover {
                        background-color: transparent !important;
                        border-color: $transparent $transparent $transparent !important;
                    }

                    &:focus {
                        background-color: $transparent !important;
                    }
                }
            }
        }
    }

    footer {

        & .share-controls {
            width: auto !important;
            top: calc(50% - 0.625rem) !important;
            left: 50% !important;
            transform: translateX(-50%) translateY(-42%) !important;

            & .addthis_toolbox {
                flex-flow: row nowrap !important;

                & > a {
                    margin: 0 12px 1px 0 !important;

                    &:last-of-type {
                        margin: 0 0 1px 0 !important;
                    }
                }
            }
        }
    }

</style>


// WEBPACK FOOTER //
// MobileInteractive.vue?56bb8986